// extracted by mini-css-extract-plugin
export default {"canvas":"App_canvas__7BC4f","modal":"App_modal__AKTbm"};